// Attributes
import bestSellers from './attributes/bestSellers'
import boltPattern from './attributes/boltPattern'
import camber from './attributes/camber'
import centerBore from './attributes/centerBore'
import centerCap from './attributes/centerCap'
import centerCapSize from './attributes/centerCapSize'
import color from './attributes/color'
import design from './attributes/design'
import designPhoto from './attributes/designPhoto'
import diameter from './attributes/diameter'
import diameterSet from './attributes/diameterSet'
import finish from './attributes/finish'
import finishStyle from './attributes/finishStyle'
import fitment from './attributes/fitment'
import fitmentTag from './attributes/fitmentTag'
import generation from './attributes/generation'
import lug from './attributes/lug'
import make from './attributes/make'
import model from './attributes/model'
import offset from './attributes/offset'
import profile from './attributes/profile'
import propertyRef from './attributes/propertyRef'
import requiredMod from './attributes/requiredMod'
import scoringCriteria from './attributes/scoringCriteria'
import spacer from './attributes/spacer'
import spacersTag from './attributes/spacersTag'
import cambersTag from './attributes/cambersTag'
import submodel from './attributes/submodel'
import tireBrand from './attributes/tireBrand'
import tireModel from './attributes/tireModel'
import tireNote from './attributes/tireNote'
import tireSize from './attributes/tireSize'
import tireTreadwear from './attributes/tireTreadwear'
import tireType from './attributes/tireType'
import width from './attributes/width'

// Documents
import accessory from './documents/accessory'
import accessoryBundle from './documents/accessoryBundle'
import accessoryCategory from './documents/accessoryCategory'
import accessoryConfiguration from './documents/accessoryConfiguration'
import aiGenerationRules from './documents/aiGenerationRules'
import album from './documents/album'
import article from './documents/article'
import articleCategory from './documents/articleCategory'
import author from './documents/author'
import buyerGuide from './documents/buyerGuide'
import centerCapsConfiguration from './documents/centerCapsConfiguration'
import centeringRingsConfiguration from './documents/centeringRingsConfiguration'
import commonPageBuilder from './documents/commonPageBuilder'
import configuration from './documents/configuration'
import configurationAccessories from './documents/configurationAccessories'
import configuratorWarning from './documents/configuratorWarning'
import constructionType from './documents/constructionType'
import customerSupportArticle from './documents/customerSupportArticle'
import resourceCenterArticle from './documents/resourceCenterArticle'
import dynamicPages from './documents/dynamicPages'
import fitmentFilter from './documents/fitmentFilter'
import fitmentGuide from './documents/fitmentGuide'
import infoBar from './documents/infoBar'
import line from './documents/line'
import lugBoltsStudsConfiguration from './documents/lugBoltsStudsConfiguration'
import modal from './documents/modal'
import promotion from './documents/promotion'
import sku from './documents/sku'
import tpmsStemsConfiguration from './documents/tpmsStemsConfiguration'
import vehicle from './documents/vehicle'
import wheelLanding from './documents/wheelLanding'
import redirect from './documents/redirect'

// Navigation Documents
import mainNav from './documents/navs/mainNav'
import footerNav from './documents/navs/footerNav'

// Single Pages
import blogHome from './documents/singles/blogHome'
import buyerGuidesTemplate from './documents/buyerGuidesTemplate'
import customerSupport from './documents/singles/customerSupport'
import settings from './documents/singles/settings'
import home from './documents/singles/home'
import vehicles from './documents/singles/vehicles'
import accessories from './documents/singles/accessories'
import cart from './documents/singles/cart'
import contact from './documents/singles/contact'
import gallery from './documents/singles/gallery'
import fitmentGuidesHome from './documents/singles/fitmentGuidesHome'
import accessoriesBanners from './documents/singles/accessoriesBanners'
import promotions from './documents/singles/promotions'
import resourceCenter from './documents/singles/resourceCenter'
import wheelLines from './documents/singles/wheelLines'
import bestSellersPage from './documents/singles/bestSellersPage'
import sprintLine from './documents/singles/sprintLine'
import comingSoon from './documents/singles/comingSoon'
import taxRefund from './documents/singles/taxRefund'
import blackFriday from './documents/singles/blackFriday'
import memorialDay from './documents/singles/memorialDay'
import project from './documents/singles/project'
import fiftyReplacement from './documents/singles/fiftyReplacement'
import realPerformancePage from './documents/singles/realPerformancePage'
import apexQualityStandard from './documents/singles/apexQualityStandard'
import replacementEligibility from './documents/singles/replacementEligibility'
import replacementWheel from './documents/singles/replacementWheel'
import fitmentHelp from './documents/singles/fitmentHelp'
import getExpertAdvice from './documents/singles/getExpertAdvice'
import warrantyCommonBlock from './documents/singles/warrantyCommonBlock'
import settingsConfiguratorAccessories from './documents/singles/settingsConfiguratorAccessories'

// Navigation Objects
import mainNavItem from './documents/navs/items/mainNavItem'
import navGroupItem from './documents/navs/items/navGroupItem'
import photoNavItem from './documents/navs/items/photoNavItem'
import navInfo from './documents/navs/items/navInfo'
import photoSubNav from './documents/navs/photoSubNav'
import infoSubNav from './documents/navs/infoSubNav'

// Objects
import afterCountdown from './objects/afterCountdown'
import beforeCountdown from './objects/beforeCountdown'
import blueCTA from './objects/blueCTA'
import compare from './objects/compare'
import contactBlock from './objects/contactBlock'
import contentCard from './objects/contentCard'
import countdownTeaser from './objects/countdownTeaser'
import difference from './objects/difference'
import differenceList from './objects/differenceList'
import faq from './objects/faq'
import feature from './objects/feature'
import featureBox from './objects/featureBox'
import fitmentBlock from './objects/fitmentBlock'
import fitmentCategory from './objects/fitmentCategory'
import fitmentListing from './objects/fitmentListing'
import fitmentListingTireNotes from './objects/fitmentListingTireNotes'
import fitmentListingTireSize from './objects/fitmentListingTireSize'
import galleryBox from './objects/galleryBox'
import graphs from './objects/graphs'
import hero from './objects/hero'
import heroButton from './objects/heroButton'
import heroSimple from './objects/heroSimple'
import infoBarLink from './objects/infoBarLink'
import infoCards from './objects/infoCards'
import lineOverview from './objects/lineOverview'
import link from './objects/link'
import loadRating from './objects/loadRating'
import myth from './objects/myth'
import myths from './objects/myths'
import promotionModal from './objects/promotionModal'
import relatedArticles from './objects/relatedArticles'
import richTable from './objects/richTable'
import sectionTheme from './objects/sectionTheme'
import sizeAlign from './objects/sizeAlign'
import sizeTable from './objects/sizeTable'
import sizesPrices from './objects/sizesPrices'
import socialMedia from './objects/socialMedia'
import specialEventCountdown from './objects/specialEventCountdown'
import specialEventHero from './objects/specialEventHero'
import specialEventPhase from './objects/specialEventPhase'
import pagePhase from './objects/pagePhase'
import specialEventPromotions from './objects/specialEventPromotions'
import specialEventSubscribe from './objects/specialEventSubscribe'
import specialEventRegistration from './objects/specialEventRegistration'
import testimonial from './objects/testimonial'
import testimonials from './objects/testimonials'
import threeBoxes from './objects/threeBoxes'
import wheelLandingCarousel from './objects/wheelLandingCarousel'
import wheelLandingOverview from './objects/wheelLandingOverview'
import years from './objects/years'
import youtubeVideo from './objects/youtubeVideo'

// PageBlocks
import PageBlocks from './pageBlocks'
import {withBlockSpacing} from './pageBlocks/blockSpacing'

export const schemaTypes = [
  // Attributes
  bestSellers,
  boltPattern,
  camber,
  cambersTag,
  centerBore,
  centerCap,
  centerCapSize,
  color,
  design,
  designPhoto,
  diameter,
  diameterSet,
  finish,
  finishStyle,
  fitment,
  fitmentTag,
  generation,
  lug,
  make,
  model,
  offset,
  profile,
  propertyRef,
  requiredMod,
  scoringCriteria,
  spacer,
  spacersTag,
  submodel,
  tireBrand,
  tireModel,
  tireNote,
  tireSize,
  tireTreadwear,
  tireType,
  width,
  
  // Documents
  accessory,
  accessoryBundle,
  accessoryCategory,
  accessoryConfiguration,
  aiGenerationRules,
  album,
  article,
  articleCategory,
  author,
  buyerGuide,
  centerCapsConfiguration,
  centeringRingsConfiguration,
  commonPageBuilder,
  configuration,
  configurationAccessories,
  configuratorWarning,
  constructionType,
  customerSupportArticle,
  resourceCenterArticle,
  dynamicPages,
  fitmentFilter,
  fitmentGuide,
  infoBar,
  line,
  lugBoltsStudsConfiguration,
  modal,
  promotion,
  sku,
  tpmsStemsConfiguration,
  vehicle,
  wheelLanding,
  redirect,
  
  // Navigation Documents
  mainNav,
  footerNav,
  
  // Single Pages
  blogHome,
  buyerGuidesTemplate,
  customerSupport,
  settings,
  home,
  vehicles,
  accessories,
  cart,
  contact,
  gallery,
  fitmentGuidesHome,
  accessoriesBanners,
  promotions,
  resourceCenter,
  wheelLines,
  bestSellersPage,
  sprintLine,
  comingSoon,
  taxRefund,
  blackFriday,
  memorialDay,
  project,
  fiftyReplacement,
  realPerformancePage,
  apexQualityStandard,
  replacementEligibility,
  replacementWheel,
  fitmentHelp,
  getExpertAdvice,
  warrantyCommonBlock,
  settingsConfiguratorAccessories,

  // Navigation Objects
  mainNavItem,
  navGroupItem,
  photoNavItem,
  navInfo,
  photoSubNav,
  infoSubNav,
  
  // Objects
  afterCountdown,
  beforeCountdown,
  blueCTA,
  compare,
  contactBlock,
  contentCard,
  countdownTeaser,
  difference,
  differenceList,
  faq,
  feature,
  featureBox,
  fitmentBlock,
  fitmentCategory,
  fitmentListing,
  fitmentListingTireNotes,
  fitmentListingTireSize,
  galleryBox,
  graphs,
  hero,
  heroButton,
  heroSimple,
  infoBarLink,
  infoCards,
  lineOverview,
  link,
  loadRating,
  myth,
  myths,
  promotionModal,
  // AR-1800: page blocks registered here (rather than in ./pageBlocks) also get the
  // shared "Spacing" control that Core/PageBuilder.vue reads.
  withBlockSpacing(relatedArticles),
  richTable,
  sectionTheme,
  sizeAlign,
  sizeTable,
  withBlockSpacing(sizesPrices),
  withBlockSpacing(socialMedia),
  specialEventCountdown,
  specialEventHero,
  specialEventPhase,
  pagePhase,
  specialEventPromotions,
  specialEventSubscribe,
  specialEventRegistration,
  testimonial,
  testimonials,
  threeBoxes,
  wheelLandingCarousel,
  wheelLandingOverview,
  years,
  youtubeVideo,

  // PageBlocks
  ...PageBlocks,
]
